<ion-card>
    <ion-fab vertical="center" horizontal="end" *ngIf="document.site && document.site.name">
        <ion-row class="ion-no-margin ion-no-padding"
                 *ngIf="document.documentNumber === 0 || document.documentType === 7">
            <ion-col class="ion-no-margin ion-no-padding">
                <ion-fab-button color="light" (click)="clearSite()" size="small">
                    <ion-icon name="close"></ion-icon>
                </ion-fab-button>
            </ion-col>
            <ion-col class="ion-no-margin ion-no-padding" *ngIf="document.documentType !== 7">
                <ion-fab-button *ngIf="document.documentNumber === 0" (click)="openModalSearch()" size="small"
                                color="light">
                    <ion-icon name="map"></ion-icon>
                </ion-fab-button>
            </ion-col>
        </ion-row>
    </ion-fab>
    <ion-card-content *ngIf="!document.site || !document.site.name" (click)="openModalSearch()">
        <ion-label>
            {{mobileConfig && mobileConfig.mobilehireHealthCareInUse === 1 ? 'Select ward...' : 'Select site...'}}
        </ion-label>
    </ion-card-content>

    <ion-card-content *ngIf="!document.site || !document.site.name">
        <h4  style="color: #ee1111"><strong>NO SITE !!!</strong></h4>
    </ion-card-content>
    
    <ion-card-content *ngIf="document.site && document.site.name">
        <h4><strong>{{document.site.name}}</strong></h4>
        <p>{{document.site.add1}}</p>
        <p>{{document.site.add2}}</p>
        <p>{{document.site.add3}}</p>
        <p>{{document.site.add4}}</p>
    </ion-card-content>


        <ion-item class="ion-no-margin" *ngIf="document.site && (document.site.add1 || document.site.add2 || document.site.add3 || document.site.add4
        || (document.site.latitude && document.site.longitude) ) "
                  (click)="navigateToSite()">
            <ion-button expand="full" shape="round" color="light" (click)="navigateToSite()">
                Navigate to Site
                <ion-icon name="compass" slot="start"></ion-icon>
            </ion-button>
        </ion-item>
</ion-card>
